/* eslint-disable max-len */
import { get, getOr, map, flow, filter, isObject } from 'lodash/fp';
import { connect } from 'react-redux';
import getInstallationPricing from '../../../helpers/installationPricing';
import DesignSummary from './DesignSummary';

import designPricing from '../../../services/designPricing/design';
import getItemsWithPurchaseOptionIn from '../../../helpers/mandi/getItemsWithPurchaseOptionIn';

const mapStateToProps = ({ estimateBuilder: { mandi, mandiAvailability, entities } }, { designId }) => {
  const products = flow(
    get('items.byId'),
    getItemsWithPurchaseOptionIn(['product-and-install', 'product-only'], designId),
    map('itemProduct'),
    filter(isObject),
  )(entities);

  const { items, containers } = entities;
  const design = get(`estimates.byId.${designId}`)(entities);

  const designPrice = designPricing(containers.byId, items.byId, 'subtotal', design);

  const { charges } = getOr({}, `designs.${designId}.pricingResult`)(mandi);
  const specMappings = getOr({}, 'specMappings')(mandiAvailability);

  const pricing = getInstallationPricing(charges, specMappings);
  const installationCosts = pricing.totalInstallationCost;

  const designNames = flow(
    get('estimates.byId'),
    map('name'),
  )(entities);

  const designName = designNames[0];
  const totalCost = designPrice + installationCosts;

  return {
    products,
    designName,
    totalCost,
  };
};

export default connect(mapStateToProps)(DesignSummary);
